<template>
  <div style="min-width: 100%">
    <h1 class="grey--text text--darken-2">Планирование работ</h1>

    <v-row class="pl-3">
      <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        max-width="460px"
        offset-y>
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="dateText"
            :reactive="false"
            label="Месяц"
            readonly
            clearable
            @click:clear="date=''; load()"
            v-on="on"
            style="max-width: 200px"/>
        </template>
        <v-date-picker
          v-model="date"
          landscape
          scrollable
          reactive
          type="month"
          locale="uk"
          @change="load()"
          @input="menu=false"/>
      </v-menu>

      <v-btn small color="yellow" @click="refreshAction" class="ml-10 mt-5">
        <v-icon left>mdi-refresh</v-icon> Обновить
      </v-btn>
      <v-btn small color="#1D6F42" dark @click="downloadAction" class="ml-3 mt-5">
        <v-icon left>mdi-microsoft-excel</v-icon> Excel
      </v-btn>
      <v-btn v-if="items.length" small :disabled="!items2accept.length" color="orange" @click="acceptAction(items2accept)" class="ml-3 mt-5">
        <v-icon left>mdi-microsoft-excel</v-icon> Утвердить
      </v-btn>
      <v-btn small color="#61a038" dark @click="planfixAction" :loading="loadingPlanfix" class="ml-3 mt-5">
        <v-icon left>mdi-send-outline</v-icon> Отправить в PlanFix
      </v-btn>
    </v-row>

    <v-row>
      <v-col>
        <v-autocomplete v-model="filters.companyID" :items="filtersData.companies" label="Компания" multiple hide-no-data hide-details clearable/>
      </v-col>
      <v-col>
        <v-autocomplete v-model="filters.brandID" :items="filtersData.brands" label="Бренд" multiple hide-no-data hide-details clearable/>
      </v-col>
      <v-col>
        <v-autocomplete v-model="filters.unitName" :items="filtersData.units" label="Юнит" multiple hide-no-data hide-details clearable/>
      </v-col>
      <v-col>
        <v-autocomplete v-model="filters.uitemStatus" :items="filtersData.statuses" label="Статус" multiple hide-no-data hide-details clearable/>
      </v-col>
    </v-row>

    <v-data-table
      v-model="selected"
      item-key="key"
      :loading="loading"
      :headers="headers"
      :items="filteredItems"
      :items-per-page="25"
      :page.sync="page"
      :footer-props="{
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
        itemsPerPageOptions: [25, 50, 100, -1],
        showFirstLastPage: true
      }"
      show-select
      no-data-text="Нет данных"
      dense
      class="elevation-1">
      <template #item.companyName="{ item }">
        {{ item.companyName }}
        <span v-if="item.client_company_id" class="font-weight-light blue-grey--text">({{ item.clientName }})</span>
      </template>
      <template #item.unitName="{ item }">
        <v-icon v-if="item.unit_is_pack && !item.parent_id" color="cyan" small class="">mdi-package-variant-closed</v-icon>
        <v-icon v-if="item.parent_id" color="orange" small class="ml-2">mdi-chevron-right</v-icon>
        <span @click="if ( item.uitemID ) editAction(item)" :class="item.uitemID ? 'editable' : ''"> {{ item.uitemName ? item.uitemName : item.unitName }}</span>
        <span class="red--text">{{ item.number ? ' #'+item.number : '' }}</span>
        <span class="orange--text text--darken-2 caption ml-1">{{ item.unitPlacement.charAt(0) == 'a' ? (item.uitemQnt ? item.uitemQnt : item.sked) : '' }}</span>
      </template>
      <template #item.uitemStatus="{ item }">
        <span v-if="item.uitemStatus=='unaccepted'">❓</span>
        <input v-if="item.unscheduled" v-model="schedule[item.key]" class="unscheduled ml-1">
        <select v-if="item.uitemStatus!='unaccepted' && (!item.unit_is_pack || item.parent_id)" class="caption" @change="statusAction($event, item)">
          <option v-for="s in filtersData.statuses.filter(s => s.value != 'unaccepted')" :key="s.value" :value="s.value" v-html="s.text" :selected="s.value==item.uitemStatus"></option>
        </select>
      </template>
      <template #item.uitemPlanfixTask="{ item }">
        <span v-if="item.uitemPlanfixTask" style="color: #61a038; cursor: pointer" @click="goPlanfixAction(item.uitemPlanfixTask)">{{ item.uitemPlanfixTask }}</span>
        <span v-else class="grey--text text--lighten-1">&mdash;</span>
      </template>
      <template #item.unitPlanPrice="{ item }">
        {{ isNaN(item.parent_id) || item.parent_id == 0 ? item.unitPlanPrice : '' }}
      </template>
    </v-data-table>

    <PlanMicrounitDialog ref="planMicrounitDialog" @updated="load()"/>
  </div>
</template>

<script>
import api from '@/api'
import { download } from '@/api'
import { microunitStatuses } from '@/common'

export default {
  components: {
    PlanMicrounitDialog: () => import('@/components/PlanMicrounitDialog.vue')
  },
  data: () => ({
    stamp: 0,
    loading: false,
    page: 1,
    loadingPlanfix: false,
    menu: false,
    date: '',
    items: [],
    selected: [],
    schedule: {},
    filters: {
      companyID: [],
      brandID: [],
      unitName: []
    },
    filtersData: {
      statuses: microunitStatuses
    },
    headers: [
      { value: 'companyName', text: 'Контрагент' },
      { value: 'brandName', text: 'Бренд' },
      { value: 'unitName', text: 'Юнит' },
      { value: 'uitemStatus', text: 'Статус', align: 'left', width: '160' },
      { value: 'uitemPlanfixTask', text: 'Planfix', align: 'center', width: '100', sortable: false },
      { value: 'unitPlanPrice', text: 'Цена, ₴', align: 'right', width: '100' },
    ],
  }),
  computed: {
    dateText () {
      let date = new Date(this.date+'-01')
      return date.getFullYear()+' — '+date.toLocaleString('uk', { month: 'long' })
    },
    filteredItems () {
      return this.items.filter(d => {
        return Object.keys(this.filters).every(f => {
          return 'undefined' === typeof d[f] || this.filters[f].length < 1 || this.filters[f].includes(d[f])
        })
      })
    },
    items2accept () {
      return this.selected.reduce((acc, cur, idx) => (cur.uitemID ? false : acc.push({key: cur.key, unitID: cur.unitID}), acc), [])
    }
  },
  mounted () {
    this.date = this.curMonth()
    this.load()
  },
  methods: {
    curMonth () {
      let d = new Date()
      let y = d.getFullYear()
      let m = d.getMonth()+1
      if ( m < 10 ) m = '0'+m
      return y+'-'+m;
    },
    columnValueList(val) { // Не подходит т.к. делает дубликаты
      return this.items.map(d => d[val])
    },
    load () {
      if ( '' == this.date ) return this.items = this.selected = []
      this.loading = true
      api.get('units/plan/' + this.date).then(response => {
        this.loading = false;
        if ( response.data.result !== 'ok' ) return this.$root.$alert(response.data.data, true)

        this.stamp = Date.now()
        this.page = 1
        this.selected = []
        this.schedule = {}
        this.filtersData.companies = []
        this.filtersData.brands = []
        this.filtersData.units = []

        this.items = response.data.data.items

        let companies = [], brands = []
        this.items.forEach((cur, idx, arr) => {
          arr[idx].key = this.stamp+'_'+idx
          if ( cur.unscheduled ) this.schedule[this.stamp+'_'+idx] = cur.unscheduled

          if ( 'undefined' === typeof cur.uitemStatus ) arr[idx].uitemStatus = 'unaccepted'
          if ( !companies.includes(cur.companyID) ) { companies.push(cur.companyID); this.filtersData.companies.push({value: cur.companyID, text: cur.companyName}) }
          if ( !brands.includes(cur.brandID) ) { brands.push(cur.brandID); this.filtersData.brands.push({value: cur.brandID, text: cur.brandName}) }
          if ( !this.filtersData.units.includes(cur.unitName) ) this.filtersData.units.push(cur.unitName)
        })
      }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
    },
    refreshAction () {
      this.load()
    },
    downloadAction () {
      download('units/plan/' + this.date + '/xls', 'export-'+this.date+'.xls')
    },
    acceptAction () {
      let accept = this.items2accept
      accept.forEach((cur, idx, arr) => typeof this.schedule[cur.key] == 'undefined' ? false : arr[idx].schedule = this.schedule[cur.key])

      this.loading = true
      api.post('units/accept', {accept: accept, ym: this.date.replace('-', '')}).then(response => {
        this.loading = false;
        if ( response.data.result !== 'ok' ) return this.$root.$alert(response.data.data, true)
        if ( response.data.data.affected > 0 ) this.load()
      }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
    },
    planfixAction () {
      this.loadingPlanfix = true
      api.post('microunits/planfix', {ym: this.date.replace('-', '')}).then(response => {
        this.loadingPlanfix = false
        if ( response.data.result !== 'ok' ) return this.$root.$alert(response.data.data, true)
        if ( response.data.data.affected > 0 )
        {
          this.$root.$alert('Передано '+response.data.data.affected+' юнитов')
          this.load()
        }
        else
          this.$root.$alert('Нет новой информации для добавления в PlanFix')
      }).catch(error => (this.loadingPlanfix = false, this.$root.$alert(error, true)) )
    },
    editAction (item) {
      this.$refs.planMicrounitDialog.edit(item)
    },
    goPlanfixAction (planfixTask) {
      window.open('https://apteka911.planfix.ua/task/'+planfixTask)
    },
    statusAction (event, item) {
      if ( event.target.value == item.uitemStatus ) return
      api.post('microunits/update/'+item.uitemID, {uitemStatus: event.target.value}).then(response => {
        this.loading = false;
        if ( response.data.result !== 'ok' ) return this.$root.$alert(response.data.data, true)
        item.uitemStatus = response.data.data.uitem.uitemStatus
        this.$root.$alert("Статус изменен")
      }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
    },
  }
}
</script>

<style>
.unscheduled { width: 50px; background-color: #ffa; font-size: 90%; }
.v-menu__content .v-list-item { min-height: 30px !important }
.v-menu__content .v-list-item__content { padding: 0 !important; }
.v-menu__content .v-list-item__action { margin: 0; }
.v-menu__content .v-list-item .v-list-item__action:first-child { margin-right: 12px !important; }
.v-menu__content .v-list-item__title { font-size: 0.92rem; }

.editable { cursor: pointer; }
.editable:hover { color: #08A2B8 !important; border-bottom: 1px #08A2B8 dashed; }
</style>
